// extracted by mini-css-extract-plugin
export default {"container":"container--mp-BcBcX","pill":"pill--mp-h7X4v","text":"text--mp-Aam6D","close-btn":"close-btn--mp-roaAp","closeBtn":"close-btn--mp-roaAp"};